exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-wrapper-select select {\n  padding-right: 1.5rem;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  background-position: center right;\n  background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" height=\"24px\" width=\"24px\" ><g><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M15.3 10.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z\" /></g></svg>');\n}\n.form-wrapper-select:hover .form-wrapper:not(.is-locked) {\n  border-color: #27cde7;\n}\n", ""]);

// exports
